import React, { useEffect, useMemo } from "react";
import { Form } from "react-bootstrap";
import { useLazyQuery } from "@apollo/client";
import { GET_CATEGORYS } from "../../graphql/category/query";

/**
 * ດຶງເລກລຳດັບການສະແດງ (sort) ທີ່ປະເພດອື່ນໃນຮ້ານໃຊ້ແລ້ວ (ຄືກັບ fourB-pos)
 *  - active: ໂຫຼດໃໝ່ທຸກຄັ້ງທີ່ເປີດ popup
 *  - shopId: ຮ້ານທີ່ກຳລັງເບິ່ງ
 *  - excludeId: id ຂອງປະເພດທີ່ກຳລັງແກ້ໄຂ (ບໍ່ນັບຕົວມັນເອງ)
 */
export function useUsedCategorySorts(active, shopId, excludeId) {
  const [loadCategories, { data, loading }] = useLazyQuery(GET_CATEGORYS, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (!active || !shopId) return;
    loadCategories({
      variables: { where: { shop: shopId, isDeleted: false }, orderBy: "sort_ASC", limit: 1000 },
    });
  }, [active, shopId]);

  const usedSorts = useMemo(
    () =>
      (data?.categories?.data || [])
        .filter((c) => typeof c?.sort === "number" && c?.id !== excludeId)
        .map((c) => ({ sort: c.sort, name: c.name }))
        .sort((a, b) => a.sort - b.sort),
    [data, excludeId]
  );

  const isTaken = (value) =>
    value !== "" && value !== null && value !== undefined &&
    usedSorts.some((u) => u.sort === parseInt(value, 10));

  return { usedSorts, isTaken, loading };
}

/** ຊ່ອງປ້ອນລຳດັບການສະແດງ + ສະແດງເລກທີ່ປະເພດອື່ນໃຊ້ແລ້ວ */
export default function CategorySortField({ value, onChange, name = "sort", usedSorts, isTaken, loading }) {
  const taken = isTaken(value);
  const takenBy = taken ? usedSorts.find((u) => u.sort === parseInt(value, 10))?.name : "";
  return (
    <Form.Group controlId="categorySort" className="w-100 mb-3">
      <Form.Label>ລຳດັບການສະແດງ (ບໍ່ບັງຄັບ)</Form.Label>
      <Form.Control
        type="number"
        name={name}
        min={1}
        step={1}
        value={value ?? ""}
        onChange={onChange}
        placeholder="ເຊັ່ນ 1, 2, 3 (ເລກນ້ອຍສະແດງກ່ອນ)"
      />
      {/* ເລກຊ້ຳ → ໃຊ້ໄດ້: ຕອນບັນທຶກ server ຈະຂະຫຍັບປະເພດເດີມຂຶ້ນ +1 */}
      {taken && (
        <div style={{ marginTop: 6, fontSize: 13, color: "#B45309" }}>
          ເລກ {value} ຖືກໃຊ້ແລ້ວ — ບັນທຶກແລ້ວ "{takenBy}" ແລະ ອັນທີ່ຕໍ່ກັນ ຈະຂະຫຍັບຂຶ້ນ +1
        </div>
      )}
      <div style={{ marginTop: 8, fontSize: 13, color: "#6B7280" }}>
        {loading ? (
          "ກຳລັງໂຫຼດເລກທີ່ໃຊ້ແລ້ວ..."
        ) : usedSorts.length === 0 ? (
          "ຍັງບໍ່ມີເລກທີ່ຖືກໃຊ້"
        ) : (
          <>
            ເລກທີ່ຖືກໃຊ້ແລ້ວ:
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
              {usedSorts.map((u) => (
                <span
                  key={`${u.sort}-${u.name}`}
                  style={{
                    background: "#F3F4F6",
                    border: "1px solid #E5E7EB",
                    borderRadius: 6,
                    padding: "2px 8px",
                  }}
                >
                  <b>{u.sort}</b> · {u.name}
                </span>
              ))}
            </div>
          </>
        )}
      </div>
    </Form.Group>
  );
}
